var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83332 11.875C5.83332 12.2204 6.11332 12.5 6.45832 12.5L13.5417 12.5C13.8871 12.5 14.1667 12.2204 14.1667 11.875C14.1667 11.7017 14.0958 11.545 13.9817 11.4317L10.4892 7.74042C10.3746 7.59542 10.1996 7.5 9.99999 7.5C9.80041 7.5 9.62541 7.59542 9.51082 7.74042L6.01791 11.4317C5.90416 11.545 5.83332 11.7017 5.83332 11.875Z",
    fill: "#758399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.57fce0c36dbe663e90dccdf8ac5616bb.svg";
export { ForwardRef as ReactComponent };